module.exports = __webpack_public_path__ + "static/media/gps.5dcd65b7.png";